<template>
    <div class='fund-reconciliation'>
        <div class="fund-reconciliation-header fx-v-center">
            <date-picker v-model="datePickerValue" @change="datePickerChange"/>
            <span v-if="isShowLiquidation"
                class="fx-v-center">
                在线支付会在清算后划款至银行卡，点击查看
                <button class="text-btn p0" 
                    @click="$router.push({
                        path: '/main/dataCenter/liquidation'
                    })">清算记录</button>
            </span>
        </div>
        <el-table v-loading="isLoading"
            ref="elTable"
            :style="{ width: elTableWidth }"
            :data="getFundData"
            :height="'calc(100vh - 195px)'"
            :empty-text="isLoading ? ' ' : '暂无数据'">
            <el-table-column
                fixed
                ref="fixed"
                label="时间"
                prop="date"
                min-width="120">
            </el-table-column>
            <el-table-column
                fixed
                ref="fixed"
                label="总收款(元)"
                min-width="130">
                <template v-slot="{ row }">
                    <p v-numberAlign>{{ getAllIncome(row.detail) }}</p>
                </template>
            </el-table-column>
            <div v-for="item in getDetailFilterWechatAlipay"
                :key="item.payment_name">
                <el-table-column min-width="130">
                <template v-slot:header="{ row }">
                    {{ item.payment_name }}
                </template>
                <template v-slot="{ row }">
                    <p v-numberAlign>{{ fixNumPro(row.detail[item.key].income) }}</p>
                </template>
            </el-table-column>
            </div>
            <el-table-column v-if="isHasOnlineIncome"
                fixed="right"
                ref="fixed"
                label="在线支付(元)"
                min-width="130">
                <template v-slot="{ row }">
                    <p v-numberAlign>{{ getOnlineIncome(row.detail) }}</p>
                </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                ref="fixed"
                label="操作"
                width="80">
                <template v-slot="{ row, $index }">
                    <button style="padding: 0" class="text-btn" @click="toOrderFormList($index, row)">详情</button>
                </template>
            </el-table-column>
            <p v-if="getFundData.length > 0 && !isLoading" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
            <!-- <p v-if="isHasMore && _isLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p> -->
            <!-- <p v-if="(!(isHasMore && _isLoading)) && getFundData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p> -->
        </el-table>
    </div>
</template>

<script lang='ts'>
import DatePicker from '@/components/date_picker/date_picker.vue'
import { createComponent, ref, Ref, onBeforeMount, onMounted, SetupContext, computed } from '@vue/composition-api'
import { openMessage } from '@/utils/system.tsx'
import { getOneMonthValue, fixNumPro } from '@/utils/index'
import $fetch from '@/api'
import dayjs from 'dayjs'
import get from 'lodash/get'
import clone from 'lodash/cloneDeep'
import { setObjectItemToFixed } from '@/utils/index'

export default createComponent({
    setup(props, ctx) {
        onMounted(()=> {
            window.location.href = 'https://ls.senguo.cc/newadmin/#/main/data/accountChecking'
        })

        const datePickerValue: Ref<any> = ref(getOneMonthValue())
        const fundData = ref<any[]>([])
        const isLoading = ref(false)
        const elTableWidth = ref('99%')  // 解决elementui对于fixed元素定位不准的问题，改变一下size就能自动调整
        // const { page: oPage, isLoading: _isLoading, isHasMore, bindListener, initScrollLoad } = useScrollLoad()

        const oRouter = ctx.root.$router
        const store = ctx.root.$store

        // not reactive data and methods
        let oLimit: number = 20
        let oFromDate = ''
        let oToDate = ''

        const format = (t?: string | Date) => dayjs(t).format('YYYY-MM-DD')

        const isShowLiquidation = computed(() => {
            const shopInfo = store.state.shop.shopInfo
            if (shopInfo == null) {
                return false
            }
            return shopInfo.pay_channel.filter(channel => {
                if (channel.channel_type === 0 && channel.status === 1) {
                    return true
                }
                return false
            }).length > 0
        })

        const isHasOnlineIncome = computed(() => {
            return getDetail.value.some(item => (item.payment_name === '微信' || item.payment_name === '支付宝'))
        })

        const getDetail = computed(() => {
            return getFundData.value.length > 0 ? getFundData.value[0].detail.filter(item => item.isShowThisColumn) : []
        })

        const getDetailFilterWechatAlipay = computed(() => {
            return getDetail.value.filter(item => (item.payment_name !== '微信' && item.payment_name !== '支付宝'))
        })

        const getFundData = computed(() => {
            if (fundData.value.length === 0) {
                return []
            }
            const arr = clone(fundData.value)
            arr.unshift(
                arr.reduce((next, prev) => {
                    prev.detail.forEach((item, i) => {
                        if (next.detail[i] == null) {
                            const newItem = clone(item)
                            newItem.income = +newItem.income
                            newItem.isShowThisColumn = false
                            newItem.key = i
                            if (!newItem.isShowThisColumn && newItem.income !== 0) {
                                newItem.isShowThisColumn = true
                            }
                            next.detail[i] = newItem
                        } else {
                            next.detail[i].income += +item.income
                            if (!next.detail[i].isShowThisColumn && next.detail[i].income !== 0) {
                                next.detail[i].isShowThisColumn = true
                            }
                        }
                    })
                    return next
                }, {
                    date: '累计',
                    detail: new Array(get(fundData, 'value[0].detail.length'))
                })
            )
            return arr
        })

        const getAllIncome = (detail) => {
            return fixNumPro(detail.reduce((next, prev) => {
                next += +prev.income
                return next
            }, 0))
        }

        const getOnlineIncome = (detail) => {
            const whiteList = ['微信', '支付宝']
            return fixNumPro(
                    detail
                    .filter(item => whiteList.includes(item.payment_name))
                    .reduce((next, prev) => {
                        next += +prev.income
                        return next
                    }, 0))
        }

        // 组件的入口
        onBeforeMount(() => {
            openMessage('warning', 'PC后台数据升级中，请前往零售通APP查看相应的数据')
            oLimit = 20
            oFromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
            oToDate = format()
            getFundReconciliationWithLoading()
        })

        // onMounted(() => {
        //     bindListener({
        //         dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
        //         loadFunction: getFundReconciliation
        //     })
        // })

        const getFundReconciliationWithLoading = () => {
            isLoading.value = true
            elTableWidth.value = '99%'
            getFundReconciliation()
                .then(() => {
                    isLoading.value = false
                    elTableWidth.value = '100%'
                })
        }

        const getFundReconciliation = (fromDate = oFromDate, toDate = oToDate) => {
            return $fetch.post({
                url: '/finance/getfundstatistics',
                params: {
                    // page,
                    // limit,
                    from_date: fromDate,
                    to_date: toDate
                }
            }).then(data => {
                console.log('资金对账', clone(data))
                // if (page === 1) {
                //     fundData.value = data.orders
                //     initScrollLoad(data)
                // } else {
                //     fundData.value = fundData.value.concat(data.orders)
                // }
                fundData.value = data
                return data
            }).catch(e => openMessage('error', e.message || '获取资金对账失败'))
        }

        // date picker change事件
        const datePickerChange = () => {
            // oPage.value = 1
            if (datePickerValue.value === null) {
                // 清空的情况
                oFromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
                oToDate = format()
            } else {
                oFromDate = format(datePickerValue.value[0])
                oToDate = format(datePickerValue.value[1])
            }
            getFundReconciliationWithLoading()
        }

        const parseMoney = (...args) => {
            return (args.reduce((next, prev) => {
                next += (+prev)
                return next
            }, 0).toFixed(2))
        }

        const toOrderFormList = (i, row) => {
            if (i !== 0) {
                oRouter.push({
                    name: 'orderFormList',
                    params: {
                        start_date: row.date,
                        end_date: row.date
                    }
                })
            } else {
                oRouter.push({
                    name: 'orderFormList',
                    params: {
                        start_date: oFromDate,
                        end_date: oToDate
                    }
                })
            }
        }

        return {
            // data
            // _isLoading,
            // isHasMore,
            isLoading,
            datePickerValue,
            getFundData,
            elTableWidth,
            // computed
            isShowLiquidation,
            isHasOnlineIncome,
            getDetailFilterWechatAlipay,
            // methods
            fixNumPro,
            getAllIncome,
            getOnlineIncome,
            datePickerChange,
            parseMoney,
            toOrderFormList
        }
    },
    components: {
        DatePicker
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-date-editor {
    margin-right: 20px;
}

.p0 {
    padding: 0;
}

.fund-reconciliation-header {
    margin-top: 12px;
    font-size: 14px;

    > span {
        line-height: 22px;
    }
}

.fund-reconciliation {
    > ::v-deep .el-table {
        position: relative;

        &::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 10px;
            height: 44px;
            background-color: #ebebeb;
        }
    }
}

::v-deep .el-table__body-wrapper {
    &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 10px;
        height: 10px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background-color: rgba(0, 0, 0, .5);
    }

    &::-webkit-scrollbar-track {
        background-color: #f7f7f7;
    }
}

::v-deep .el-table__fixed-right {
    right: 10px !important;
}
</style>